module.exports = __webpack_public_path__ + "static/media/alliance-marketing.c3450c5d.jpg";